
export const DRAYAGE_ORIGIN = 'https://drayage.atmavaan.com';
// export const DRAYAGE_ORIGIN = 'http://localhost:4207';

function isDrayageUrl(url: string): boolean {
  try {
    const u = new URL(url);
    return u.origin === DRAYAGE_ORIGIN || u.hostname === 'drayage.atmavaan.com';
  } catch {
    return false;
  }
}

export function returnToDrayage(token: string, redirectUrl: string | null | undefined): boolean {
  if (typeof window === 'undefined' || !token || !redirectUrl || !isDrayageUrl(redirectUrl)) return false;
  const u = new URL(redirectUrl);
  const path = (u.pathname + u.search).replace(/^\//, '') || 'main/dashboard';
  window.location.href = u.origin + '/redirect?' + new URLSearchParams({ token, url: path }).toString();
  return true;
}

// any link from the website into drayage: signed in -> pass the token; signed out -> tell drayage to sign out too
export function drayageLink(path: string = 'main/dashboard'): string {
  const token = typeof window !== 'undefined' ? localStorage.getItem('x-token') : null;
  const url = path.replace(/^\//, '');
  const params: Record<string, string> = token ? { token, url } : { logout: '1', url };
  return DRAYAGE_ORIGIN + '/redirect?' + new URLSearchParams(params).toString();
}
